export const ROUTES = {
   TEMPLATES: '/templates',
   LIVE:'/live',
   PROFILE_PAGE: '/profile',
   ADD_CONFIGURATION: '/add-configuration',
   REDIRECT_PAGE: '/install',
   TRACK_PAGE: '/REFEXG/',
};

export const PAGE_TITLES = {
    [ROUTES.TEMPLATES]: 'Template Page',
    [ROUTES.LIVE]: 'Live Page',
    [ROUTES.ADD_CONFIGURATION]: 'Add Configuration',
    [ROUTES.PROFILE_PAGE]: 'Profile Page',
};
